module.exports = __webpack_public_path__ + "static/img/6.88c5439.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/6.png
// module id = sIWp
// module chunks = 0